<template>
<v-container>

    <div>
        <v-breadcrumbs :items="breadcrumbs" v-if="$local_storage.get('tipo_usuario') == 'Super Usuario' || $local_storage.get('id_cliente') > 0">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-row>

        <v-col cols="12">
            <base-material-card color="primary" icon="library_books" title="Clientes Disponibles" class="px-5 py-3">
                <v-card-text class="pa-0">

                    <div id="datagrid" v-on:keyup.enter="$refs.pagination_pw.filterData()">

                        <v-client-table ref="vuetable" id="lista_clientes" :data="clientes.items" :columns="columns" :options="options" class="elevation-2 pa-2">
                            <template slot="noResults">
                                <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                            </template>

                            <template slot="select" slot-scope="props">
                                <v-btn fab x-small color="primary" @click="carga_datos(props.row.id, props.row.rfc, props.row.razon, props.row.num, props.row.dias_cliente)">
                                    <v-icon>input</v-icon>
                                </v-btn>
                            </template>
                        </v-client-table>
                        <template>
                            <div v-if="pwPagination.total > 0">
                                <div class="mt-3">
                                    <PaginacionComponent ref="pagination_pw" :total='pwPagination.total' :links="pwPagination.links" :items="clientes" :options="pwPagination.options"></PaginacionComponent>
                                </div>
                            </div>
                        </template>
                    </div>

                </v-card-text>

                <!--     <v-card-actions>
            <v-btn
              color="success"
              min-width="100"
              class="pl-0"
            >
              Sign In
            </v-btn>
          </v-card-actions> -->
            </base-material-card>
        </v-col>

    </v-row>

</v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
import PaginacionComponent from '@/components/PaginacionComponent.vue';

export default {
    created: function () {

    },
    mounted: function () {
        this.$local_storage.set("soloCartaPorte", 0);
        this.$local_storage.set("carta_porte", 0);
        this.$store.state.carta_porte = 0;
        this.$local_storage.set("id_cliente", 0);
        this.$local_storage.set("soloSA31", 0);
        this.$local_storage.set('sa31', 0);
        this.$local_storage.set("soloSA24", 0);
        this.$local_storage.set('sa24', 0);
        this.$local_storage.set("cambio_cliente", true);
        this.$local_storage.set("rfc", "");
        this.$local_storage.set("razon", "");

        if (this.$local_storage.get("tipo_usuario") == "Super Usuario" || this.$local_storage.get("tipo_usuario") == "Soporte") {
            this.$local_storage.set("panel_grupo", 0);
            this.$local_storage.set("es_transportista", 0);
            this.$local_storage.set("es_agente", 0);
            this.$local_storage.set("rfc_grupo", "");
            this.$local_storage.set("nombre_grupo", "");
            this.$local_storage.set("id_grupo", 0);
        }
        if (this.$local_storage.get("padre_id_grupo") > 0) {
            this.$local_storage.set("panel_grupo", this.$local_storage.get("padre_panel_grupo"));
            this.$local_storage.set("es_transportista", this.$local_storage.get("padre_es_transportista"));
            this.$local_storage.set("es_agente", this.$local_storage.get("padre_es_agente"));
            this.$local_storage.set("rfc_grupo", this.$local_storage.get("padre_rfc_grupo"));
            this.$local_storage.set("nombre_grupo", this.$local_storage.get("padre_nombre_grupo"));
            this.$local_storage.set("id_grupo", this.$local_storage.get("padre_id_grupo"));
        }
        //   if(this.$local_storage.get("id_grupo" ) > 0){
        this.$local_storage.set("padre_panel_grupo", this.$local_storage.get("panel_grupo"));
        this.$local_storage.set("padre_es_transportista", this.$local_storage.get("es_transportista"));
        this.$local_storage.set("padre_es_agente", this.$local_storage.get("es_agente"));
        this.$local_storage.set("padre_rfc_grupo", this.$local_storage.get("rfc_grupo"));
        this.$local_storage.set("padre_nombre_grupo", this.$local_storage.get("nombre_grupo"));
        this.$local_storage.set("padre_id_grupo", this.$local_storage.get("id_grupo"));
        // }

        this.$user.set({
            id_cliente: 0
        });
        this.$store.state.id_cliente = -1;
        if (this.$local_storage.get("tipo_usuario") == "Cliente") {
            delete this.options.headings["fecha_ingreso"];
            delete this.options.headings["fecha_vencimiento"];
            var keyFI = 0;
            var keyFV = 0;
            for (var k in this.columns) {
                if (this.columns[k] == "fecha_ingreso") keyFI = k;
                if (this.columns[k] == "fecha_vencimiento") keyFV = k;
            }
            if (keyFI > 0) delete this.columns[keyFI];
            if (keyFV > 0) delete this.columns[keyFV];
        }
        this.mostrarmenu()

        this.carga_clientes();
        this.model_filters = this.$refs.vuetable.query
    },
    watch: {
        model_filters: {
            handler(val) {
                this.pwPagination.options.filters = {
                    usuario: this.$local_storage.get("id_usuario"),
                    sistema: this.$sistema,
                    filtros: {
                        nombre__icontains: this.model_filters.razon,
                        identificador__icontains: this.model_filters.rfc,
                        fecha_ingreso__icontains: this.model_filters.fecha_ingreso,
                        fecha_vencimiento__icontains: this.model_filters.fecha_vencimiento
                    }
                }
            },
            deep: true
        }
    },
    computed: {
        computeLogo() {
            return "/static/logo_blanco.png";
        }
    },
    components: {
        "PaginacionComponent": PaginacionComponent
    },
    methods: {
        carga_clientes: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var data = {
                usuario: this.$local_storage.get("id_usuario"),
                sistema: this.$sistema,
            };

            var url = this.$hostname + "usuarios/get_clientes_usuario/";

            var self = this;
            axios
                .post(url, data)
                .then(function (response) {
                    if (self.$local_storage.get("tipo_usuario") == "Cliente") {
                        self.lista_clientes = response.data.results;
                        let item_clientes = [];

                        let consignatario = 0;
                        response.data.results.forEach(function (element, index) {
                            if (element.id_perfil != undefined && element.id_perfil == 43) {
                                consignatario += 1;
                            }
                        });

                        if (consignatario == self.lista_clientes.length) {
                            self.$local_storage.set("perfil_grupo", 43);
                            self.$router.replace("/trafico/reporte_embarques").catch(() => {});
                        } else {
                            self.$local_storage.set("perfil_grupo", 0);
                        }
                        self.mostrarmenu(true);
                        self.clientes.items = response.data.results;
                        self.pwPagination.total = response.data.count;
                        self.pwPagination.links.next = response.data.next;
                        self.pwPagination.links.prev = response.data.previous;

                    } else {
                        self.clientes.items = response.data.results;
                        //console.log(response.data.results);
                        /*   self.clientes.items.sort(function(a, b){
                                  if(a['razon'] > b['razon'])
                                      return 1;
                                  else if(a['razon'] < b['razon'])
                                      return -1;

                                  return 0;
                              }); */
                        self.pwPagination.total = response.data.count;
                        self.pwPagination.links.next = response.data.next;
                        self.pwPagination.links.prev = response.data.previous;
                    }
                    self.$root.$dialogLoader.hide();
                })
                .catch(function (error) {

                    console.log(error);
                    self.$root.$dialogLoader.hide();
                    //   self.$router.push("/").catch(()=>{});

                });
        },

        regresar() {
            if (this.$local_storage.get("id_cliente") > 0) {
                this.$router.push("/home").catch(() => {});
            } else {
                if (this.$local_storage.get("tipo_usuario") == "Super Usuario") {
                    this.$router.push("/admin").catch(() => {});
                } else {
                    this.$router.push("/").catch(() => {});
                }
            }
        },
        mostrarmenu: function (val) {
            //Se actualiza la variable store.state.datetime para forzar a recargar el componente de AppBar.vue
            //Esta variable se manda llamar en el archivo App.vue
            this.$store.state.datetime = moment(new Date()).format("x"); //Unix timestamp
        },
        inicializapermisos: async function (estatus) {
            var result = [];
            var data = {
                sistema: this.$sistema,
                headers: {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                }
            };

            var url = this.$hostname + "sistemas/get_permisos_sistema/";
            let self = this;
            await axios
                .post(url, data)
                .then(function (response) {
                    response.data.forEach(function (element) {
                        self.$local_storage.set(element.clave, estatus);
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });
            return result;
        },
        permisoscliente: async function (id_cliente) {
            //Si es un usuario de grupo, puede tener un perfil, si es asi que cargue permisos de ese perfil
            var perfil = parseInt(this.$local_storage.get("perfil_grupo", 0));
            var data = {
                sistema: this.$sistema,
                cliente: id_cliente,
                id_perfil: perfil,
            };

            var url = this.$hostname + "perfiles/get_permisos_perfil/";
            let self = this;
            await axios
                .post(url, data)
                .then(function (response) {

                    response.data.forEach(function (element) {
                        if (perfil > 0) { //Si tiene perfil, solo debe cargar permisos activos
                            if (element.activo == 1) {
                                self.$local_storage.set(element.clave, 100);
                            }
                        } else {
                            self.$local_storage.set(element.clave, 100);
                        }
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });

            for (var i = 1; i < 19; i++) {
                self.$local_storage.set("Modulo" + i, 0);
            }

            data = {
                cliente: id_cliente
            };
            await axios
                .post(self.$hostname + "clientes-sistemas/list_modulos_cliente/", data)
                .then(response => {
                    response.data.forEach(function (m) {
                        self.$local_storage.set("Modulo" + m.modulo, 100);
                    });
                    if (response.data.length == 1 && self.$local_storage.get("Modulo13") == 100) {
                        self.$local_storage.set("soloCartaPorte", 100);
                    } else {
                        self.$local_storage.set("soloCartaPorte", 0);
                    }
                    if (response.data.length == 1 && (self.$local_storage.get("Modulo15") == 100 || self.$local_storage.get("Modulo16") == 100) ) {
                        self.$local_storage.set("soloSA31", 100);
                    } else {
                        self.$local_storage.set("soloSA31", 0);
                    }
                    if (response.data.length == 1 && (self.$local_storage.get("Modulo18") == 100 ) ) {
                        self.$local_storage.set("soloSA24", 100);
                    } else {
                        self.$local_storage.set("soloSA24", 0);
                    }
                })
                .catch(error => {
                    console.log(error);
                });

        },
        permisosusuario: async function (id_cliente, perfil) {
            var data = {
                sistema: this.$sistema,
                cliente: id_cliente,
                id_perfil: 0,
            };

            var url = this.$hostname + "perfiles/get_permisos_perfil/";
            let self = this;
            let permisos_cliente = [];
            await axios
                .post(url, data)
                .then(function (response) {
                    response.data.forEach(function (element) {
                        permisos_cliente.push(element.clave);
                    });
                    // carga los permisos del usaurio
                    perfil.forEach(function (element) {
                        if (permisos_cliente.includes(element.clave))
                            self.$local_storage.set(element.clave, "100");
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        carga_datos: async function (id_cliente, rfc, razon, index, dias_cliente) {
           let self = this;
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            this.$local_storage.set("rfc", rfc);
            this.$local_storage.set("razon", razon);
            this.$local_storage.set("id_cliente", id_cliente);
            this.$local_storage.set("dias_cliente", dias_cliente);
            this.$local_storage.set("trafico", 0);
            this.$local_storage.set("costing", 0);
            this.$local_storage.set("emanifiesto", 0);
            this.$local_storage.set("carta_porte", 0);
            this.$local_storage.set("panel_grupo", 0);
            this.$local_storage.set("es_transportista", 0);
            this.$local_storage.set("rfc_grupo", "");
            this.$local_storage.set("nombre_grupo", "");
            this.$local_storage.set("id_grupo", 0);
            this.$local_storage.set("soloSA31", 0);
            this.$local_storage.set('sa31', 0);
            this.$local_storage.set("soloSA24", 0);
            this.$local_storage.set('sa24', 0);

            this.$user.set({
                id_cliente: id_cliente
            });

            var d_acceso = {
                "usuario": this.$local_storage.get("id_usuario"),
                "cliente": this.$local_storage.get("id_cliente")
            };

            axios.post(this.$hostname + "accesos_usuarios/save_acceso_cliente/", d_acceso).then(res => {}).catch(error => {});

            await this.inicializapermisos(0); //desactiva todos los permisos
            if (typeof index !== "undefined") {
                if (this.lista_clientes[index].perfil.length > 0) {
                    var permisos = this.lista_clientes[index].perfil;
                    if (this.lista_clientes[index].id_perfil != undefined)
                        this.$local_storage.set("perfil_grupo", this.lista_clientes[index].id_perfil);
                    else
                        this.$local_storage.set("perfil_grupo", 0);

                    this.$local_storage.set("id_perfil", 1); // variable que indica que si tiene un perfil

                    await this.permisoscliente(id_cliente);
                    await this.permisosusuario(id_cliente, this.lista_clientes[index].perfil);
                    /*   let self = this;
                      permisos.forEach(function(element) {
                          self.$local_storage.set(element.clave, 100); // se activan los permisos que tiene el perfil
                      }); */
                } else {
                    this.$local_storage.set("id_perfil", 0);
                    //cargar permisos del sistema
                    await this.permisoscliente(id_cliente);
                }
            } else {
                await this.permisoscliente(id_cliente);
            }
            this.$store.state.id_cliente = id_cliente;

            this.$local_storage.set('trafico', 0);
            this.$local_storage.set('costing', 0);
            this.$local_storage.set('emanifiesto', 0);
            this.$local_storage.set("carta_porte", 0);
            this.$local_storage.set("sa31", 0);
            this.$local_storage.set("sa24", 0);

            this.$root.$dialogLoader.hide();

            if (this.$local_storage.get("perfil_grupo") == 43) {
                this.$router.replace("/trafico/reporte_embarques").catch(() => {});
            }
            if (this.$local_storage.get("Modulo14") == 100)
                this.$router.replace("/indexAAC").catch(() => {});
            if (this.$local_storage.get("soloCartaPorte") == 100)
                this.$router.replace("/index").catch(() => {});

            if (this.$local_storage.get("soloSA31") == 100)
                this.$router.replace("/indexsa31").catch(() => {});

            if (this.$local_storage.get("soloSA24") == 100)
                this.$router.replace("/indexsa24").catch(() => {});

            if (self.$local_storage.get("Modulo18") == 100 && (self.$local_storage.get("Modulo15") == 100 || self.$local_storage.get("Modulo16") == 100) && self.$local_storage.get("Modulo6") != 100  ){
                console.log("LLEGA");
                self.$router.replace("/vacio").catch(() => {});
            }
                

            if (this.$local_storage.get("VUCEM.Pedimento.consulta.pedimento") == 100 &&
                this.$local_storage.get("VUCEM.Pedimento.consulta.cove") == 100) {
                this.$router.replace("/home").catch(() => {});
            } else {
                if (this.$local_storage.get("DATA.STAGE.cargazip") == 100)
                    this.$router.replace("/datastage/bitacorazip").catch(() => {});
                else if (this.$local_storage.get("VUCEM.Transmision.ver.coves") == 100)
                    this.$router.replace("/transmision/covedetalles").catch(() => {});
                else if (this.$local_storage.get("VUCEM.Pedimento.consulta.pedimento") == 100)
                    this.$router.replace("/reportes/consultar_pedimentos_ws").catch(() => {});
            }
          

        },

    },

    data() {
        return {
            model_filters: '',
            pwPagination: {
                total: 0,
                links: {
                    url: this.$hostname + "usuarios/get_clientes_usuario/",
                    next: '',
                    prev: '',
                },
                options: {
                    tipo: 1,
                    size: 10,
                    loading: this.showLoading,
                    filters: {}
                }
            },
            name: "datagrid",
            columns: ["select", "rfc", "razon"],
            options: {
                filterable: ["rfc", "razon"],
                sortable: ["rfc", "razon"],
                headings: {
                    select: "",
                    rfc: "RFC o TAX ID",
                    razon: "Razón Social",
                },
                filterAlgorithm: {
                    rfc: function () {
                        return true;
                    },
                    razon: function () {
                        return true;
                    }
                },
            },
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/admin"
                },
                {
                    text: "Lista de Clientes",
                    disabled: true,
                    href: ""
                }
            ],
            search: "",
            show_loading: true,
            lista_clientes: [],
            clientes: {
                selected: [],
                headers: [{
                        text: "",
                        value: "icon"
                    },
                    {
                        text: "RFC ",
                        value: "rfc"
                    },
                    {
                        text: "RAZÓN SOCIAL ",
                        value: "razon"
                    }
                ],
                items: [0]
            }
        };
    }
};
</script>

<style>
#lista_clientes tr td:nth-child(1) {
    width: 60px;
}

#lista_clientes tr td:nth-child(2) {
    width: 200px;
}
</style>
